module.exports = __webpack_public_path__ + "static/media/logo.6d83a430.png";